import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import { PROJECTS } from '../lib/data';
import './PortfolioCarousel.css';

const AUTOPLAY_INTERVAL = 6000;

export default function PortfolioCarousel() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [progress, setProgress] = useState(0);
  const totalSlides = PROJECTS.length;

  useEffect(() => {
    let start = null;
    let animationFrameId;

    const tick = (timestamp) => {
      if (!start) start = timestamp;
      const elapsed = timestamp - start;
      const newProgress = Math.min((elapsed / AUTOPLAY_INTERVAL) * 100, 100);
      setProgress(newProgress);

      if (elapsed < AUTOPLAY_INTERVAL) {
        animationFrameId = requestAnimationFrame(tick);
      } else {
        setCurrentSlide((prev) => (prev + 1) % totalSlides);
        start = null;
        setProgress(0);
        animationFrameId = requestAnimationFrame(tick);
      }
    };

    animationFrameId = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(animationFrameId);
  }, [currentSlide, totalSlides]);

  const handleNext = () => {
    setCurrentSlide((prev) => (prev + 1) % totalSlides);
    setProgress(0);
  };

  const handlePrev = () => {
    setCurrentSlide((prev) => (prev - 1 + totalSlides) % totalSlides);
    setProgress(0);
  };

  const currentProject = PROJECTS[currentSlide];

  return (
    <section className="portfolio-premium">
      <div className="portfolio-bg-text">
        SELECTED WORKS — 2026 — SINIX STUDIO — SELECTED WORKS — 2026
      </div>

      <div className="portfolio-layout">
        <div className="portfolio-images">
          {PROJECTS.map((project, idx) => {
            let className = 'portfolio-slide';
            if (idx === currentSlide) className += ' active';
            else if (idx === (currentSlide - 1 + totalSlides) % totalSlides) className += ' prev';
            
            return (
              <img 
                key={project.slug} 
                src={project.cover} 
                alt={project.name} 
                className={className} 
                loading="lazy"
              />
            );
          })}
        </div>

        <div className="portfolio-card">
          <div className="portfolio-card-index">
            {String(currentSlide + 1).padStart(2, '0')} / {String(totalSlides).padStart(2, '0')}
          </div>
          
          <div className="portfolio-card-header" key={`header-${currentSlide}`}>
            <h3>{currentProject.name}</h3>
            <p className="tags">{currentProject.tags.join(' • ')}</p>
          </div>

          <div className="portfolio-card-footer">
            <div className="portfolio-progress">
              <div 
                className="portfolio-progress-bar" 
                style={{ width: `${progress}%` }}
              />
            </div>
            
            <div className="portfolio-nav">
              <Link to="/work" className="view-case-study">See All Case Study</Link>
              <div className="portfolio-nav-buttons">
                <button onClick={handlePrev} aria-label="Previous Slide">
                  <ArrowLeft size={20} />
                </button>
                <button onClick={handleNext} aria-label="Next Slide">
                  <ArrowRight size={20} />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
